import HttpRequest from '@/libs/axios2'
const baseUrl = process.env.NODE_ENV === 'development' ? "http://127.0.0.1:38088" : "http://127.0.0.1:38088"

const axios1 = new HttpRequest(baseUrl)
export default axios1
